import { render, staticRenderFns } from "./Toasts.vue?vue&type=template&id=1c8b878d&scoped=true"
import script from "./Toasts.vue?vue&type=script&lang=js"
export * from "./Toasts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8b878d",
  null
  
)

export default component.exports